import {
    inspectionItemLabel,
    InspectionTask,
} from 'aos-services/src/services/tasks/types/task/InspectionTask'
import { TaskTemplate } from 'aos-services/src/services/tasks/types/task/TaskTemplate'
import { Box } from 'aos-ui-universal'
import { TFunction } from 'i18next'
import React from 'react'

import type { PropsListEntry } from '../PropsListEntry'

export const inspectionTaskPropertyList =
    (translate: TFunction) =>
    (t: InspectionTask | TaskTemplate<InspectionTask>): PropsListEntry[] => [
        [
            'tasks.task-preview.inspection',
            !!t.items?.length && (
                <Box>
                    {t.items.map((ch, index) => (
                        <Box key={index}>{inspectionItemLabel(translate)(ch)}</Box>
                    ))}
                </Box>
            ),
        ],
    ]
